import ApiClient from './ApiClient';

export function fetchCurrentUserDetails() {
    return ApiClient.get('auth/user');
}

export function fetchCurrentUserApplications() {
    return ApiClient.get('auth/user/applications');
}

export function fetchUser(uuid) {
    return ApiClient.get('/users/' + uuid);
}

export function updateUser(uuid, data) {
    return ApiClient.put('/users/' + uuid, data)
}

export function checkPassword(uuid, password) {
    return ApiClient.post('/users/' + uuid + '/check-password', {plainPassword: password})
}

export function changePassword(id, {oldPassword, password, passwordRepeat}) {
    return ApiClient.patch('/users/' + id + '/change-password', {plainPassword: password, plainPasswordRepeat: passwordRepeat, oldPassword})
}

export function updateUserPhoto(uuid, photo) {
    return ApiClient.put('/users/' + uuid + '/photo/' + photo)
}

export function deleteUserPhoto(uuid) {
    return ApiClient.delete('/users/' + uuid + '/photo')
}
